import React from "react";
import { useAuth } from "../lib/auth";
import { useNavigate } from "react-router-dom";
import { baseUrl, TOKEN_KEY } from "../lib/api";
import AppHeader from "../components/AppHeader";
import ShareLinkCards from "../components/ShareLinkCards";
import { Download, LogOut, UserCog, Sheet, Mail, ChevronRight, Zap, CalendarX, FileText } from "lucide-react";

export default function More() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const isAdmin = user?.role === "admin";

  const exportCsv = async (kind) => {
    try {
      const token = localStorage.getItem(TOKEN_KEY);
      const res = await fetch(`${baseUrl}/api/export/${kind}.csv`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      if (!res.ok) throw new Error("Could not download");
      const csv = await res.text();
      const blob = new Blob([csv], { type: "text/csv" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = `studio-grape-${kind}.csv`; a.click();
      URL.revokeObjectURL(url);
    } catch (e) { alert(e?.message || "Export failed"); }
  };

  return (
    <>
      <AppHeader title="More" />
      <div className="sg-main sg-fade-in">
        <div className="sg-card" style={{ marginBottom: 18, display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ width: 46, height: 46, borderRadius: 23, background: "var(--brand)", color: "#fff", display: "grid", placeItems: "center", fontWeight: 800, fontSize: 18 }}>
            {(user?.name || "U").charAt(0).toUpperCase()}
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 15, fontWeight: 800, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{user?.name}</div>
            <div style={{ fontSize: 12, color: "var(--muted)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{user?.email}</div>
          </div>
          <span style={{ background: "var(--surface-subtle)", color: "var(--brand)", padding: "4px 10px", borderRadius: 6, fontSize: 10, fontWeight: 800, letterSpacing: 0.6 }}>{(user?.role || "").toUpperCase()}</span>
        </div>

        <div className="sg-section-h" style={{ marginTop: 0 }}>Shareable Links</div>
        <ShareLinkCards />

        <div className="sg-section-h">Export</div>
        <NavRow icon={<Download size={17} color="var(--brand)" />} label="Export Customers (CSV)" onClick={() => exportCsv("customers")} testId="export-customers" />
        <NavRow icon={<Download size={17} color="var(--brand)" />} label="Export Meetings (CSV)" onClick={() => exportCsv("meetings")} testId="export-meetings" />

        <div className="sg-section-h">Workspace</div>
        <NavRow icon={<FileText size={17} color="var(--brand)" />} label="Initial Meeting Docs" onClick={() => navigate("/initial-docs")} testId="more-initial-docs" />
        {isAdmin && (
          <>
            <NavRow icon={<UserCog size={17} color="var(--brand)" />} label="Team & Roles" onClick={() => navigate("/team?tab=members")} testId="more-team" />
            <NavRow icon={<Mail size={17} color="var(--brand)" />} label="Allowed Staff Emails" onClick={() => navigate("/team?tab=invites")} testId="more-allowed" />
            <NavRow icon={<CalendarX size={17} color="var(--brand)" />} label="Blocked Meeting Slots" onClick={() => navigate("/blocked-slots")} testId="more-blocked-slots" />
            <NavRow icon={<Sheet size={17} color="var(--brand)" />} label="Google Sheets Sync" onClick={() => navigate("/sheets")} testId="more-sheets" />
          </>
        )}
        <NavRow icon={<Zap size={17} color="var(--brand)" />} label="Follow-ups" onClick={() => alert("Follow-ups coming soon")} testId="more-followups" />

        <NavRow
          icon={<LogOut size={17} color="var(--danger)" />}
          label="Sign out"
          danger
          onClick={async () => { if (window.confirm("Sign out?")) { await signOut(); navigate("/login"); } }}
          testId="more-signout"
        />

        <div style={{ textAlign: "center", color: "var(--muted)", fontSize: 11, marginTop: 28 }}>Studio Grape · v1.0</div>
      </div>
    </>
  );
}

function NavRow({ icon, label, onClick, testId, danger }) {
  return (
    <button
      onClick={onClick}
      data-testid={testId}
      style={{
        width: "100%", display: "flex", alignItems: "center", gap: 12, padding: "14px 14px",
        background: "var(--surface)", border: "1px solid var(--line)", borderRadius: 12,
        cursor: "pointer", marginBottom: 8, textAlign: "left",
      }}
    >
      {icon}
      <span style={{ flex: 1, fontSize: 14, fontWeight: 700, color: danger ? "var(--danger)" : "var(--ink)" }}>{label}</span>
      <ChevronRight size={16} color="var(--muted)" />
    </button>
  );
}
